import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'canton',
  standalone: true,
})
export class CantonPipe implements PipeTransform {
  cantonsMap = {
    ag: 'Argovie',
    ai: 'Appenzell Rhodes-Intérieures',
    ar: 'Appenzell Rhodes-Extérieures',
    be: 'Berne',
    bl: 'Bâle-Campagne',
    bs: 'Bâle-Ville',
    fr: 'Fribourg',
    ge: 'Genève',
    gl: 'Glaris',
    gr: 'Grisons',
    ju: 'Jura',
    lu: 'Lucerne',
    ne: 'Neuchâtel',
    nw: 'Nidwald',
    ow: 'Obwald',
    sg: 'Saint-Gall',
    sh: 'Schaffhouse',
    so: 'Soleure',
    sz: 'Schwytz',
    tg: 'Thurgovie',
    ti: 'Tessin',
    ur: 'Uri',
    vd: 'Vaud',
    vs: 'Valais',
    zg: 'Zoug',
    zh: 'Zurich',
  };

  transform(value: string): string {
    return this.cantonsMap[value] ?? value;
  }
}
